import { Route } from '@angular/router';
import { chatFeatureRoutes } from '@iese-chatbot/chat-feature';

export const appRoutes: Route[] = [
  { path: '', redirectTo: '/chat', pathMatch: 'full' },
  ...chatFeatureRoutes,
  { path: '**', redirectTo: '/chat' },
];
